import React from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import SectionReveal from '../components/SectionReveal';
import './Services.css';

function Services() {
  return (
    <main className="services-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">What We Offer</span>
            <h1>Our Services & Partnerships</h1>
            <p>Elevating health for individuals, athletes, and corporate teams.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="services-full-grid">
            {config.services.map((service, idx) => (
              <SectionReveal key={service.id} delay={idx * 0.1}>
                <div className="service-full-card">
                  <div className="service-full-card__icon">{service.icon}</div>
                  <div className="service-full-card__content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <ul className="service-full-card__benefits">
                      {service.benefits.map((b, i) => (
                        <li key={i}>✅ {b}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </SectionReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Corporate CTA */}
      <section className="section corporate-cta-section">
        <div className="container">
          <SectionReveal>
            <div className="corporate-cta-card">
              <div className="corporate-cta-card__content">
                <span className="section-badge" style={{background: 'rgba(255,255,255,0.15)', color: '#fff'}}>For Businesses</span>
                <h2>Want to boost your team's health?</h2>
                <p>Request a free corporate trial. Fresh fruit cups for your office — delivered daily.</p>
                <div style={{display: 'flex', gap: '16px', flexWrap: 'wrap'}}>
                  <Link to="/corporate-trial" className="btn btn-primary">
                    Request a Corporate Trial
                  </Link>
                  <a href={`tel:${config.contact.phoneRaw}`} className="btn" style={{background: 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)'}}>
                    📞 {config.contact.phone}
                  </a>
                </div>
              </div>
              <div className="corporate-cta-card__visual">
                <img src="/images/fruit-cup-top.jpg" alt="Fresh fruit cup" />
              </div>
            </div>
          </SectionReveal>
        </div>
      </section>
    </main>
  );
}

export default Services;
